import React, { Component, Suspense } from 'react';
import {
  // AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarHeader,
  AppSidebarForm,
  AppSidebarNav,
  AppSidebarFooter,
  AppSidebarMinimizer
} from '@coreui/react';

import $ from 'jquery';
import { defaultProps } from 'recompose';
import sidebarImage from "assets/img/backgrounds/jehyun-sung-483873-unsplash.jpg";


// const Footer = React.lazy(() => import('./RenterFooter'));
const RenterHeader = React.lazy(() => import('./RenterHeader'));

class RenterDashboardLayout extends Component {
  loading = () => (
    <div className="animated fadeIn pt-1 text-center">
      <div className="sk-spinner sk-spinner-pulse" />
    </div>
  );

  componentDidMount(){
    if (this.props.layout.sidebar === true){
      $('body').addClass('sidebar-lg-show');
      $('body').addClass('sidebar-fixed');
      $('body').addClass('header-fixed');
    }
    if (this.props.layout.sidebar === false){
      $('body').removeClass('sidebar-lg-show');
      $('body').removeClass('sidebar-fixed');
      $('body').removeClass('header-fixed');
    }
  }


  render() {
    return (
      <div className="app">
        <AppHeader
          fixed
          className='renter d-flex flex-row justify-content-between renter'
        >
          <Suspense fallback={this.loading()}>
            <RenterHeader {...this.props} />
          </Suspense>
        </AppHeader>

        <div className="app-body renter-admin">
          {
            this.props.layout.sidebar && <AppSidebar
              fixed
              display="lg"
              style={{ backgroundImage: `url(${sidebarImage})` }}
            >
              <AppSidebarHeader />
              <AppSidebarForm />
              <Suspense>
                <AppSidebarNav navConfig={{ items: this.props.navConfig }} />
              </Suspense>
              <AppSidebarFooter />
              <AppSidebarMinimizer />
            </AppSidebar>
          }
          <main className="main d-flex flex-column">
            <Suspense fallback={this.loading()}>
              {this.props.children}
            </Suspense>
          </main>
        </div>

        {/* <AppFooter className="renter">
          <Suspense fallback={this.loading()}>
            <Footer />
          </Suspense>
        </AppFooter> */}
      </div>
    )
  }
}

const withDefaults = defaultProps({
  routes: [],
  navigation: { items: [] }
});

export default withDefaults(RenterDashboardLayout);
